import { useControllerConnectionStatus } from '../../Hooks/useControllerConnectionStatus';
import { useState } from 'react';
import { AppBar, Box, Tab } from '@material-ui/core';
import TabContext from '@material-ui/lab/TabContext';
import TabList from '@material-ui/lab/TabList';
import TabPanel from '@material-ui/lab/TabPanel';
import { useTranslation } from 'react-i18next';
import { ShowSetting } from '../../FormWidgets/ShowSliderSetting';
import { SettingGroupGrid } from '../../FormWidgets/SettingGroup';
import { SettingActions } from '../../components';
import { useIsMobile } from '../../Hooks/useMedia';

export default function CirculationSettings({ controller, values, saved, controls, disabled }) {
  const { status: connectionStatus, disabledReason: connectionDisabledReason } =
    useControllerConnectionStatus(controller);

  const { t } = useTranslation();
  const mobile = useIsMobile();
  const [subzone, setSubzone] = useState('0');
  return (
    <TabContext value={subzone}>
      <AppBar
        position="static"
        color="default"
        style={
          mobile
            ? {
                boxSizing: 'border-box',
                margin: '16px 0',
                padding: '0 8px',
                width: '100%'
              }
            : { margin: '24px 0' }
        }
      >
        <Box display="flex" justifyContent="center" width="100%">
          <TabList
            variant="scrollable"
            scrollButtons="auto"
            onChange={(_, value) => setSubzone(value)}
            aria-label={t('ventilation_circulation')}
          >
            {values.map((_, index) => (
              <Tab
                key={index}
                value={String(index)}
                label={`${t('ventilation_circulation')} ${index + 1}`}
                id={`circulation-tab-${index}`}
                aria-controls={`circulation-tabpanel-${index}`}
              />
            ))}
          </TabList>
        </Box>
      </AppBar>
      {!disabled && (
        <SettingActions
          title={connectionDisabledReason}
          on_default={connectionStatus !== 'good'}
          onReset={controls.resetSettings}
          onSave={controls.saveSettings}
        />
      )}
      {values.map((value, index) => (
        <TabPanel
          key={index}
          value={String(index)}
          id={`circulation-tabpanel-${index}`}
          style={{ padding: 0 }}
        >
          <SettingGroupGrid controller={controller} id="circulation_power">
            {['day', 'night', 'co2'].map((phase) => (
              <ShowSetting
                key={`${index}-${phase}`}
                id={`circulation.${index}.${phase}`}
                show={`circulation_power_${phase}`}
                controller={controller}
                cur_value={value[phase]}
                controller_value={saved[index][phase]}
                controls={controls}
                disabled={disabled}
                min={9}
                max={100}
                off_at={9}
                unit=" %"
              />
            ))}
          </SettingGroupGrid>
        </TabPanel>
      ))}
    </TabContext>
  );
}
